import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function AddComment() {
  var tskid = localStorage.getItem('taskid');
  var prdid = localStorage.getItem('taskproid');
  var timespan = 0;
  const navigate = useNavigate();
  const [listTaskCommArra, setTaskCommArray] = useState([]);
  useEffect(() => {
    var obj = {
      pr_key: tskid
    };

    console.log(obj);

    fetch('getAllTskCommentById.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.json()) // PHP returns json_encode($data)
      .then(result => {

        if (result && result !== 'fail') {
          var arr = result;

          console.log(arr);

          var len = Array.isArray(arr) ? arr.length : 0;

          if (len < 1) {
            document.getElementById('comnum').innerText = '0';
            document.querySelector('.notice_text').style.display = 'block';
          } else {
            document.getElementById('comnum').innerText = len;
            setTaskCommArray(arr);
          }

        } else {
          showAlert('Cannot found any task for this project.');
          document.getElementById('nocomms').style.display = 'block';
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }, [])

  function saveCooment() {
    var ctext = $('#comm_text').val();
    var role = localStorage.getItem('user_position');
    var memname = localStorage.getItem('membername');
    var memberid = localStorage.getItem('member_id');
    var files = $('#comm_file')[0].files; // array of selected files

    let formData = new FormData();

    formData.append('tskid', tskid);
    formData.append('memberid', memberid);
    formData.append('proid', prdid);
    formData.append('comtext', ctext);
    formData.append('memrole', role);
    formData.append('memname', memname);
    formData.append('assignDate', getCurrentDateTime());

    // Append files
    for (let i = 0; i < files.length; i++) {
      formData.append('attachments[]', files[i]);
    }

    fetch('save_tsk_comment.php', {
      method: 'POST',
      body: formData
    })
      .then(response => response.text()) // because PHP returns "success" or "fail"
      .then(response => {
        console.log(response);

        if (response !== 'fail') {
          navigate('/re_tskdetails');
        } else {
          showAlert("Cannot save your comment");
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }

  function editcomm(pr_text, ind) {
    var idtooff = 'context' + ind;
    var idtoon = 'editbox' + ind;
    $('#' + idtooff).css('display', 'none');
    $('#' + idtoon).css('display', 'block');
    $('#' + idtoon + ' textarea').val(pr_text)
  }

  function returntotext(ind) {
    var idtoon = 'context' + ind;
    var idtooff = 'editbox' + ind;
    $('#' + idtooff).css('display', 'none');
    $('#' + idtoon).css('display', 'block');
    $('#' + idtooff + ' textarea').val('')
  }

  function editComtext(id, ind) {
    var idtoedit = 'editbox' + ind;
    var editcont = $('#' + idtoedit + ' textarea').val()
    console.log(idtoedit + ' : ' + editcont)
    if (editcont == '') {
      alert('Insert text to update')
    } else {
      var pr_key = localStorage.getItem('taskid');

      var obj = {
        comment_desc: editcont,
        comment_id: id,
        pr_key: pr_key
      };

      console.log(obj);

      fetch('edit_comnent_details.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(obj)
      })
        .then(response => response.text()) // IMPORTANT: because PHP returns plain text
        .then(result => {
          console.log(result);

          if (result !== 'fail') {
            navigate('/re_tskdetails');
          } else {
            showAlert('Cannot remove member.');
          }
        })
        .catch(error => {
          console.error("Fetch Error:", error);
        });
    }
  }


  function getCurrentDateTime() {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = today.getFullYear();

    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const seconds = String(today.getSeconds()).padStart(2, '0');

    // Format: MM-DD-YYYY HH:mm:ss
    return `${mm}-${dd}-${yyyy} ${hours}:${minutes}:${seconds}`;
  }


  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function openCommentPop() {
    $('#comm_pop').addClass('activepop');
  }

  function closeCommentArea() {
    $('#comm_pop').removeClass('activepop');
  }

  function removeimg(ind) {
    var obj = {
      primary_key: ind
    };

    console.log(obj);

    fetch('removeCommentImage.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.text()) // IMPORTANT (not json)
      .then(result => {
        console.log(result);

        // handle all success possibilities
        if (result !== 'fail' && result !== '' && result !== '0') {
          navigate('/re_tskdetails');
        } else {
          showAlert('Cannot remove image.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }


  const isEditable = (sub_date) => {
    // Convert MM-DD-YYYY HH:mm:ss to a valid Date
    const [datePart, timePart] = sub_date.split(' ');
    const [mm, dd, yyyy] = datePart.split('-');
    const [hh, min, ss] = timePart.split(':');

    const postedTime = new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`).getTime();
    const now = Date.now();
    const diffMinutes = (now - postedTime) / (1000 * 60);
    return diffMinutes <= 30;
  };

  return (
    <div>
      <div className='comholder'>
        <div className='com_top_bar'>
          <button onClick={openCommentPop}>Comment</button>
        </div>
        <div className='comm_list'>
          <p>Comments : <span id="comnum"></span></p>
          <h3 className="notice_text">No comments found</h3>
          {listTaskCommArra.map((item, index) => {
            const editable = isEditable(item.sub_date);
            const creatorid = item.memberid
            const userid = localStorage.getItem('member_id');
            const canEdit = editable && Number(creatorid) === Number(userid);
            console.log(userid + ' : ' + creatorid + ' : ' + editable)

            return (
              <div className='comm_row' key={index}>
                <div className='fullwidth pull_left pt-10'>
                  {canEdit && (
                    <button
                      className='back_btn'
                      onClick={() => { editcomm(item.comtext, index) }}
                    >
                      <i className="ri-edit-fill"></i>
                    </button>
                  )}
                </div>

                <p id={`context${index}`}>{item.comtext}</p>

                <div className='fullwidth no-display' id={`editbox${index}`}>
                  <textarea className='contexteditbox'></textarea>
                  <div className='edit_btn_holder'>
                    <button className='contexteditboxbutton' onClick={() => { editComtext(item.primary_key, index) }}>Update</button>
                    <button className='contentclosebtn' onClick={() => { returntotext(index) }}>Close</button>
                  </div>
                </div>

                <p>
                  <i>Attachment:{" "}</i>
                  {item.files && item.files.map((f, i) => (
                    <p className='attachment_tag' key={i}>
                      Attachment {i + 1}: <a href={f.link} target="_blank">{f.name.toUpperCase()}{f.type.toUpperCase()}</a>
                      {canEdit && (
                        <i className='ri-delete-bin-3-fill removeicoImg' onClick={() => { removeimg(f.id) }}></i>
                      )}
                    </p>
                  ))}
                </p>

                <p className='infotext'>
                  <span>Posted by: </span>{item.memname}/{item.memrole}
                </p>
                <p className='infotext'>
                  <span>Date: </span>{item.sub_date}
                </p>
              </div>
            );
          })}
        </div>

        <div className='comm_area_text' id="comm_pop">
          <button className="clsbtn" onClick={closeCommentArea}><i class="ri-close-line"></i></button>
          <textarea id="comm_text"></textarea>
          <div className='uploadarea'>
            <input type="file" id="comm_file" multiple />
          </div>
          <button onClick={saveCooment}>Submit</button>
        </div>

        <div className='vl_dsh_popup' id="alertpop">
          <div className='alertbox'>
            <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
            <div className='contentarea'>
              <p id="alert_text"></p>
            </div>
            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
